import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StateService } from '../services/state.service';

export function phoneVerifiedGuard(): CanActivateFn {
  return () => {
    const stateService = inject(StateService);
    const router       = inject(Router);

    const user = stateService.getCurrentUser();
    if (!user) { router.navigate(['/login']); return false; }

    // Only restricts self-registered users that still need phone validation
    if (!user.requiresPhoneValidation) return true;

    // Both email and phone must be verified
    if (user.validated && (user as any).phoneValidated) return true;

    // Stay logged in, redirect to unified validation page
    router.navigate(['/validate']);
    return false;
  };
}
